module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ded#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface1#preface1"
    }
  }, [_vm._v("Preface to the American Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Ancestral Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("‘Passionate Resolves’: Eton, 1872–1878")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("3. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("‘Laying the Foundations’: Oxford, 1878–1883")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("4. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4"
    }
  }, [_vm._v("Twin Passions: ‘Women and Work’, 1882–1885")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("5. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5"
    }
  }, [_vm._v("The Journey to Westminster, 1885–1887")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("6. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6"
    }
  }, [_vm._v("‘Travel with a Purpose’, 1887–1890")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Coming Man’, 1890–1895")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hearts and Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Number Two at the FO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailing to Bombay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Governance of India")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Let India Be My Judge’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Partners and Colleagues: The Problem of the Princes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guarding the Frontiers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Viceroy’s Routine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("16. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1902: Proconsular Zenith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("17. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatal Appointments, 1902–1903")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("18. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gulf, Bengal and Tibet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("19. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘An Infinitude of Trouble’: England, 1904")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("20. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kitchener’s Conspiracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("21. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Breaking of the Viceroy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("22. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Every Man’s Hand’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("23. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Picking Up the Pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("24. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Conversion of a Diehard, 1909–1911")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("25. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suffragists and Other Targets, 1911–1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("26. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lord Curzon at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("27. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Search of a Role, 1914–1915")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("28. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air Board and War Cabinet, 1916")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("29. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Lady Curzon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("30. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eastern Questions, 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("31. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lord President")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("32. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Foreign Office at Last")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("33. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Middle Eastern Scrambles, 1919–1922")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("34. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lloyd George and the Turks, 1919–1922")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("35. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resurgence: Lausanne, 1922–1923")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("36. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Sagas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("37. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultimate Disappointments, 1923–1925")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chronology#chro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources and Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#idx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#acd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by David Gilmour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0